import 'bootstrap/dist/css/bootstrap.css';
import 'wfp-ui/dist/css/bootstrap-theme.css';
import 'wfp-ui/dist/css/wfpui.css';
import 'wfp-ui/dist/assets/fonts/aleo/aleo.css';
import 'wfp-ui/dist/assets/fonts/lato/lato.css';
import './styles/daterangepicker.scss';
import './styles/main.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from '@wfp-root-app/store/store';

import App from './app/App';
import { useRootAuthConfig } from './app/auth';
import { AuthContextProvider } from './common/auth/AuthContext';

createRoot(document.getElementById('root')!).render(
    <Provider store={store as any}>
        <BrowserRouter>
            <AuthContextProvider authConfig={useRootAuthConfig}>
                <App />
            </AuthContextProvider>
        </BrowserRouter>
    </Provider>
);
